export default __webpack_public_path__ + "static/media/Q13.cfbceb70.jpg";